import type { CurrentUser } from '@ochal/types';
export interface LoginCredentials {
  identity: string;
  password: string;
  remember: boolean;
  captchaId?: string;
  captchaAnswer?: string;
  replaceSessionId?: string;
}
export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
}
export interface AuthSession {
  user: CurrentUser;
  tokens: AuthTokens;
  policy?: { idleTimeoutMs: number; absoluteExpiresAt: number };
}
export interface AuthAdapter {
  login(credentials: LoginCredentials): Promise<AuthSession>;
  logout(): Promise<void>;
  refresh(refreshToken: string): Promise<AuthTokens>;
  getSession(): Promise<AuthSession | null>;
  /** Refreshes server-side activity without rotating credentials. */
  touchSession?(): Promise<void>;
}
export class SessionExpiredError extends Error {
  constructor() {
    super('نشست شما منقضی شده است.');
    this.name = 'SessionExpiredError';
  }
}
